export default __webpack_public_path__ + "static/media/cart.eff7b914.svg";